export function formatPrice(value, currency = "") {
  const n = Number(value || 0);
  return currency ? `${currency} ${n.toFixed(2)}` : n.toFixed(2);
}

// orders.delivery_address is a free-text column that's cast to 'array' but
// only actually decodes to an array/object for storefront-checkout orders
// (denzo-web's Cart.js sends {first_name, last_name, area, ...}) — a
// POS/waiter-created delivery order just stores a plain string, which the
// array cast round-trips as-is. Mirrors denzo-admin's own Order.js field
// ordering (first_name/last_name, then area, then whatever else is present)
// but folds it into one display line instead of a list of chips.
export function formatDeliveryAddress(addr) {
  if (!addr) return "";
  if (typeof addr === "string") return addr;
  const parts = [];
  const name = [addr.first_name, addr.last_name].filter(Boolean).join(" ");
  if (name) parts.push(name);
  if (addr.area) parts.push(addr.area);
  Object.keys(addr).forEach((key) => {
    if (key !== "first_name" && key !== "last_name" && key !== "area" && addr[key]) parts.push(addr[key]);
  });
  return parts.join(", ");
}

// orders.gps_location is {lat, lng} JSON captured at checkout — same shape
// denzo-admin's "Direction" button already opens
// (Pages/Orders/Order.js:123-133). Reusing that exact plain-Google-Maps-link
// pattern here too: no maps SDK/API key needed.
export function mapUrl(gps) {
  if (!gps || gps.lat == null || gps.lng == null) return null;
  return `http://maps.google.com/?saddr=My+location&daddr=${gps.lat},${gps.lng}`;
}
